import { VerticalView } from './vertical-view';
/**
 * day view
 */
export class Day extends VerticalView {
    /**
     * Constructor for day view
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    constructor(parent) {
        super(parent);
        this.viewClass = 'e-day-view';
    }
    /**
     * Get module name.
     *
     * @returns {string} Returns the module name.
     */
    getModuleName() {
        return 'day';
    }
}
